import {
  FlashcardActivityProgressFilters,
  listFlashcardActivityProgress,
} from '@/data/services/flashcardActivityProgressServices';

export const flashcardActivityProgressQueries = {
  all: ['flashcardActivityProgress'] as const,

  list: (filters: FlashcardActivityProgressFilters = {}) => ({
    queryKey: [
      ...flashcardActivityProgressQueries.all,
      'list',
      { filters },
    ] as const,
    queryFn: () => listFlashcardActivityProgress(filters),
  }),
};
